import posthog from "posthog-js";

const posthogEnabled = import.meta.env.VITE_POSTHOG_KEY;

type IdentifyUserParams = {
  id: string;
  name: string;
  email: string;
  userType: string;
};

/**
 * Identify the current user in PostHog for analytics tracking
 */
export const identifyUser = ({
  id,
  name,
  email,
  userType,
}: IdentifyUserParams): void => {
  if (!posthogEnabled) {
    return;
  }

  posthog.identify(id, {
    name: name,
    userType,
    email,
  });
};

/**
 * Track a custom event in PostHog
 * @param event - Event name
 * @param properties - Optional event properties
 */
export const trackEvent = (event: string, properties?: object): void => {
  if (!posthogEnabled) {
    return;
  }

  posthog.capture(event, properties);
};
